import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const AdminPostEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [form, setForm] = useState({
        title: '',
        slug: '',
        body: '',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                const res = await fetch('/api/posts');
                if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
                const data = await res.json();
                const post = (data || []).find(p => String(p.post_id) === String(id));
                if (!post) throw new Error('Post not found');
                setForm({
                    title: post.title || '',
                    slug: post.slug || '',
                    body: post.body || '',
                });
            } catch (err) {
                setError(err.message || 'Unknown error');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        
        try {
            const token = window.localStorage.getItem('token');
            const res = await fetch(`/api/posts/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(form),
            });
            
            if (!res.ok) {
                const text = await res.text();
                throw new Error(text || `Failed to update post: ${res.status}`);
            }
            
            const data = await res.json();
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.message || 'Unknown error');
            setLoading(false);
        }
    };

    if (loading && !form.title) return <div className="text-white">Loading…</div>;

    return (
        <div className="text-white">
            <h1>Edit Blog Post</h1>
            {error && <div className="text-red-500 mb-16">Error: {error}</div>}
            <form onSubmit={handleSubmit} className="grid gap-12 mt-16" style={{ maxWidth: 640 }}>
                <input 
                    className="input-box" 
                    name="title" 
                    placeholder="Title" 
                    value={form.title} 
                    onChange={handleChange} 
                    required 
                />
                <input 
                    className="input-box" 
                    name="slug" 
                    placeholder="Slug (URL-friendly title)" 
                    value={form.slug} 
                    onChange={handleChange} 
                    required 
                />
                <textarea 
                    className="input-box" 
                    name="body" 
                    placeholder="Post content" 
                    value={form.body} 
                    onChange={handleChange} 
                    required
                    rows={15}
                />
                <div className="flex gap-12">
                    <button 
                        type="submit" 
                        className="px-24 py-12 bg-color-dark text-white br-5" 
                        disabled={loading}
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button 
                        type="button" 
                        className="px-24 py-12 br-5" 
                        onClick={() => navigate('/admin/dashboard')} 
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AdminPostEdit;

